import {request, serviceUrl} from "@/utils/request";

// 获取空间地图信息
export function getSpaceMap(spaceId) {
  return request({
    url: serviceUrl.spaceService + '/space/map/list-by-space-id',
    params: {
      spaceId
    }
  })
}

// 更新地图信息
export function update(spaceMap) {
  return request({
    url: serviceUrl.spaceService + '/space/map/update',
    data: spaceMap,
    method: 'post'
  })
}
